<ngx-spinner name="" bdColor="rgba(255,255,255,0.8)" size="medium" color="#6366f1" type="ball-scale-multiple"
    [fullScreen]="true">
</ngx-spinner>
<ngx-spinner name="dark" bdColor="rgba(0,0,0,0.8)" size="medium" color="#6366f1" type="ball-scale-multiple"
    [fullScreen]="true">
</ngx-spinner>
<router-outlet></router-outlet>